export default {
  black: '#000000',
  blackLight: '#121212',
  blackSmallLogo: '#070707',
  white: '#FFFFFF',
  lightGrin: '#E9F0C8',
  lightPink: '#FDE1CC',
  darkGreen: '#0D3831',
  darkOrange: '#CF5031',
  lightOrange: '#FFBA00',
  orange: '#F39800',
  lightBlack: '#121212',
  lightGray: '#F5F5F5',
  darkGray: '#9D9D9D',
  gray: '#EDEDED',
  lightBlue: '#D4EDF9',
  darkBlue: '#3E88C2',
};
